import { render, staticRenderFns } from "./input-image.vue?vue&type=template&id=2d1fa8ba"
import script from "./input-image.vue?vue&type=script&lang=js"
export * from "./input-image.vue?vue&type=script&lang=js"
import style0 from "./input-image.vue?vue&type=style&index=0&id=2d1fa8ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports